import { render } from "./NewVisit.vue?vue&type=template&id=a2bd5bf8&scoped=true"
import script from "./NewVisit.vue?vue&type=script&lang=js"
export * from "./NewVisit.vue?vue&type=script&lang=js"

import "./NewVisit.vue?vue&type=style&index=0&id=a2bd5bf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2bd5bf8"]])

export default __exports__